import RoleCreateEdit from "../components/roleCreateEdit";
import RoleList from "../components/roleList";
import { Navigate } from "react-router-dom";
import SvgIcons from "../../../../shared/components/svgIcons";

const roleRoute = {
  icon: SvgIcons.UserControlsIcon,
  name: "Users and Controls",
  link: "/users-controls",
  path: "/user-controls",
  element: "",
  index: 990,
  children: [
    {
      path: "roles",
      element: <RoleList />,
      name: "Roles and Permissions",
      permission: "Roles and Permissions",
      index: 2,
      link: "user-controls/roles",
      icon: SvgIcons.RolesIcon,
    },
    {
      path: "roles/create",
      element: <RoleCreateEdit />,
    },
    {
      path: "roles/:id",
      element: <RoleCreateEdit />,
    },
    {
      path: "",
      element: <Navigate to="roles" replace />,
    },
  ],
};
export default roleRoute;
